/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddDepartmentPhoneNumberRequestBody = {
    properties: {
        phonenumbers: {
    type: 'array',
    contains: {
        type: 'DepartmentPhoneNumberRequestBody',
    },
},
    },
};